import {Inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {Observable, of, of as observableOf} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';

import {PersonaService} from "../../../../../chacra-core";
import * as personasActions from './personas.actions';
import {ConfigService} from '../../../../../shared';
import {DOCUMENT} from '@angular/common';
import {AUTH_ACCESS_TOKEN, AUTH_ROLE_ID} from '../../../../../core';
import {LocalStorageService} from '../../../../../core/services';

@Injectable()
export class PersonasEffects {
  PersonasLoadRequestEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<personasActions.PersonasLoadRequestAction>(
      personasActions.PersonasActionTypes.PERSONAS_LOAD_REQUEST
    ),
    switchMap((action) => {
      const rolId = this.localStorageService.getItem(AUTH_ROLE_ID);
      let params: any = {rolId};
      return this.personasCoreService.get(params).pipe(
        map(queryResults => {
          return new personasActions.PersonasLoadSuccessAction({
            items: queryResults.items
          });
        }),
        catchError(error =>
          observableOf(
            new personasActions.PersonasLoadFailureAction({
              error
            })
          )
        )
      );
    })
  ));

  // load
  // register
  personasRegistrerRedirectEffect = createEffect(() =>
      this.actions$.pipe(
        ofType(personasActions.PersonasActionTypes.PERSONAS_REGISTRER_REDIRECT),
        tap(() => {
            const appConfig = ConfigService.getAppConfig();
            if (appConfig.reuneBaseUrl !== '') {
              const accessToken = this.localStorageService.getItem(AUTH_ACCESS_TOKEN);
              const callbakURL = this.document.defaultView.window.location.href + '/callback';
              const url = `${appConfig.reuneBaseUrl}reuneredirect.aspx?0,${appConfig.systemId},${appConfig.profileUrl}`;
              console.log('url', url)
              this.document.defaultView.window.open(url, '_self');
            } else {
              console.error('Debe configurar el valor de reuneBaseUrl en su config.json');
              of(
                new personasActions.PersonasRegistrerFailureAction({
                  error: 'Ha ocurrido un error el el registro de persona en el REUNE.'
                })
              );
            }
          }
        )
      ),
    {dispatch: false}
  );

  constructor(
    private personasCoreService: PersonaService,
    private actions$: Actions,
    @Inject(DOCUMENT) readonly document: Document,
    private localStorageService: LocalStorageService
  ) {
  }
}
